import { defineComponent, ref, useSlots, computed, createElementBlock, openBlock, normalizeClass, createVNode, mergeProps, withCtx, createCommentVNode, createElementVNode, renderSlot } from 'vue';
import _sfc_main$1 from './basler-components.es121.js';
import { useSlotContent } from './basler-components.es362.js';

const _hoisted_1 = { class: "card__content" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Card",
  props: {
    hasLargeGutter: { type: Boolean, default: false },
    headerGutter: { type: Boolean, default: false },
    link: { default: void 0 },
    hasLinkBehavior: { type: Boolean, default: false }
  },
  setup(__props) {
    const footer = ref(null);
    const slots = useSlots();
    const { hasSlotContent } = useSlotContent();
    const hasHeaderSlotContent = computed(() => {
      return hasSlotContent(slots.header);
    });
    const hasFooterSlotContent = computed(() => {
      return hasSlotContent(slots.footer);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("article", {
        class: normalizeClass(["card", { "card--large-gutter": _ctx.hasLargeGutter }, { "card--has-link": _ctx.link || _ctx.hasLinkBehavior }])
      }, [
        createVNode(_sfc_main$1, mergeProps(_ctx.link, { "is-renderless": true }), {
          default: withCtx(() => [
            hasHeaderSlotContent.value ? (openBlock(), createElementBlock("header", {
              key: 0,
              class: normalizeClass(["card__header", { "card__header--with-gutter": _ctx.headerGutter }])
            }, [
              renderSlot(_ctx.$slots, "header")
            ], 2)) : createCommentVNode("", true),
            createElementVNode("div", _hoisted_1, [
              renderSlot(_ctx.$slots, "default")
            ]),
            hasFooterSlotContent.value ? (openBlock(), createElementBlock("footer", {
              key: 1,
              ref_key: "footer",
              ref: footer,
              class: "card__footer"
            }, [
              renderSlot(_ctx.$slots, "footer")
            ], 512)) : createCommentVNode("", true)
          ]),
          _: 3
        }, 16)
      ], 2);
    };
  }
});

export { _sfc_main as default };
